import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from './login/login-callback.component';
import { LogoutComponent } from './logout/logout.component';
import { OktaLoginCallbackGuard } from '../guards/okta-login-callback';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
    canActivate: [OktaLoginCallbackGuard],
    data: {},
    title: 'Logging in...',
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
    data: {},
    title: 'Login',
  },
  {
    path: 'logout',
    pathMatch: 'full',
    component: LogoutComponent,
    data: {},
    title: 'Logout',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
